import type { IconSvgObject } from './types';

const FlagOffIcon: IconSvgObject = [
  ["path", { d: "M4 14L4 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.00876 3.00876C9.16422 2.95225 10.4492 3.16236 11.7576 3.83892C14.4173 5.21419 17.3096 5.2316 20 4.00813V14.0232C19.8133 14.1268 19.5912 14.2341 19.3381 14.3381M4.24191 4.24191C4.15535 4.30176 4.0746 4.3614 4 4.42024V14.8254C4.9697 13.7112 7.87879 11.9841 11.7576 13.9897C12.8503 14.5547 13.9344 14.8438 14.9505 14.9505", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 3L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FlagOffIcon;
